// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TihlshHYkgEYNWIUbWSD {
  width: 48px;
  height: 48px;
  border: 5px solid #fff;
  border-bottom-color: #0e82fd;
  border-radius: 50%;
  display: inline-block;
  box-sizing: border-box;
  animation: fkYawJKTCnAM_PCXDfy9 1s linear infinite;
}

@keyframes fkYawJKTCnAM_PCXDfy9 {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Loader/index.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,4BAA4B;EAC5B,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;EACtB,kDAAsC;AACxC;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF","sourcesContent":[".loader {\n  width: 48px;\n  height: 48px;\n  border: 5px solid #fff;\n  border-bottom-color: #0e82fd;\n  border-radius: 50%;\n  display: inline-block;\n  box-sizing: border-box;\n  animation: rotation 1s linear infinite;\n}\n\n@keyframes rotation {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"loader": `TihlshHYkgEYNWIUbWSD`,
	"rotation": `fkYawJKTCnAM_PCXDfy9`
};
export default ___CSS_LOADER_EXPORT___;
